import ApiService from "@services/api.service";
import {Notify} from 'quasar';
export const etudiantTestPositionnement = {
  state: {
    tests: [],
    test: null,
  },
  mutations: {
    setTestsPositionnements(state, tests){
      state.tests = tests;
    },
    setTestPositionnement(state, test){
      state.test = test;
    }
  },
  actions:{
    //Récupère le nombre de tests de positionnements réalisés
    //Controller GetTestPositionnement
    async fetchTestsPositionements(context){
      try{
        const response = await ApiService.getRequest('get_tests_positionnements');
        context.commit('setTestsPositionnements', response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est porduite lors de la récuptération des données",
          color: 'red'
        })
      }
    },
    // Récupere les tests d'un étudiant données pour afficher la vue dans la fiche bénéficiare
    async fetchLightTestPositionnements(context, stagiaire){
      try{
        const response = await ApiService.getRequest(`get_test_positionement_light/${stagiaire}`);
        context.commit("setTestsPositionnements", response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    }
  },
  getters:{
    getTestsPositonnements(state){
      return state.tests;
    },
    getTestPositonnement(state){
      return state.test;
    }
  },
}
